import { gql } from '@grandvisionhq/graphql';
import BillingAddressFragment from '../fragments/billing-address.js';

var GET_BILLING_ADDRESS = gql`
  query getBillingAddress {
    me {
      id
      defaultBillingAddress {
        ...BillingAddressFragment
      }
    }
  }
  ${BillingAddressFragment}
`;

export { GET_BILLING_ADDRESS as default };
//# sourceMappingURL=get-billing-address.js.map
